module.exports = {
    "ApiUrl": "https://rm-api-pbrctest.icarehealth.com.au/api/",
    "IdentityServerAuthority": "https://rm-identity-pbrctest-resman.icarehealth.com.au",
    "SignalRUrl": "https://rm-api-pbrctest.icarehealth.com.au/signalr",
    "AutomationEnabled": true,
    "MedicareTimeZone": "Australia/Melbourne"
};